var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 10.8334C10.4628 10.8334 10.8359 10.4603 10.8359 10C10.8359 9.53978 10.4628 9.16669 10.0026 9.16669C9.54237 9.16669 9.16927 9.53978 9.16927 10C9.16927 10.4603 9.54237 10.8334 10.0026 10.8334Z",
    stroke: "#B2B5AD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 10.8334C16.2962 10.8334 16.6693 10.4603 16.6693 10C16.6693 9.53978 16.2962 9.16669 15.8359 9.16669C15.3757 9.16669 15.0026 9.53978 15.0026 10C15.0026 10.4603 15.3757 10.8334 15.8359 10.8334Z",
    stroke: "#B2B5AD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16927 10.8334C4.62951 10.8334 5.0026 10.4603 5.0026 10C5.0026 9.53978 4.62951 9.16669 4.16927 9.16669C3.70903 9.16669 3.33594 9.53978 3.33594 10C3.33594 10.4603 3.70903 10.8334 4.16927 10.8334Z",
    stroke: "#B2B5AD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e7697240fc371a949f66b295e166594.svg";
export { ForwardRef as ReactComponent };